import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Redirect from "../../components/modal/redirect/Redirect";

function Register() {
  const navigate = useNavigate();
  const [userInputs, setUserInputs] = useState({
    username: "",
    email: "",
    password: "",
  });

  const [err, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const changeHandler = (e) => {
    setUserInputs({ ...userInputs, [e.target.name]: e.target.value });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  return (
    <div className="auth">
      <h1 className="auth__title">Register</h1>
      <form className="auth__form">
        <input
          required
          placeholder="username"
          type="text"
          name="username"
          className="auth__form__username"
          onChange={changeHandler}
        />
        <input
          required
          placeholder="email"
          type="text"
          name="email"
          className="auth__form__email"
          onChange={changeHandler}
        />
        <input
          required
          placeholder="password"
          type="password"
          name="password"
          className="auth__form__password"
          onChange={changeHandler}
        />
        <button onClick={submitHandler} className="auth__form__btn">
          Register
        </button>
        <span className="auth__form__option">
          Already have an account? <Link to="/Login">Login</Link>
        </span>
      </form>
      {showModal && <Redirect setShowModal={setShowModal} />}
    </div>
  );
}

export default Register;
